import './App.css';
import Lite from './components/Lite';
import { ConfigProvider, Layout } from 'antd';
import { Header, Content, Footer } from 'antd/es/layout/layout';

function App() {

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#722ed1',
            fontFamily: 'Poppins'
          },
        }}
      >
        <Layout className='layout'>
          <Header className='logo'>
            <span className='logoText'>SCHÄTZOMATIV</span>
          </Header>
          <Content className='content'>
            <Lite />
          </Content>
          <Footer className='footer'>
            <div className='footerLine'></div>
            Schätzomativ ©{new Date().getFullYear()} by Lukas Bumberger
          </Footer>
        </Layout>
      </ConfigProvider>
    </>
  );

}

export default App;